import { TStiReportData } from '@infotech-soe/merps';
import {
  IAbstractGroupControl,
  IAbstractInputControl,
  IFormParsed,
  ILabelControl,
} from '@infotech-soe/metaschema';

import CachedSchemaRepository from '../../../infrastructure/schemas/storage/CachedSchemaRepository';
import ISchemaRepository from '../../../infrastructure/schemas/storage/ISchemaRepository';
import { FormTitle } from '../FormTitle';
import { FormControlViewModelType } from '../view-model/FormControlViewModel';
import { PredefinedForms } from '../view-model/FormCreateViewModel';
import { FormSource } from '../view-model/FormSource';

abstract class FormSchemaFactory {
  protected schemaRepository: ISchemaRepository;
  constructor() {
    this.schemaRepository = new CachedSchemaRepository();
  }

  protected abstract get(source: FormSource): Promise<IFormParsed>;
}

export abstract class AbstractPredefinedFormSchemaFactory<
  T extends PredefinedForms = PredefinedForms.TREE,
> {
  public abstract getTitle: () => FormTitle;
  public abstract getFormSchema: T extends PredefinedForms.REVIEW
    ? (
        template: string,
        data: TStiReportData['data'],
        variables?: Record<string, any>
      ) => Promise<IFormParsed>
    : () => Promise<IFormParsed>;
}

export interface IReportControl {
  control: FormControlViewModelType.REPORT;
  name: string;
  template: string;
  value: string;
  variables?: Record<string, any>;
}

export type IExtendedControl =
  | IAbstractInputControl
  | ILabelControl
  | IAbstractGroupControl
  | IReportControl;

export interface IExtendedFormParsed extends Omit<IFormParsed, 'Layout'> {
  Layout: IExtendedControl[];
}

export default FormSchemaFactory;
